<script>
  import { ERROR_CRITICAL, ERROR_WARNING } from '../js/constants.js';
  import { CLEAR } from '../js/l10n/en_US.js';

  export let error,
    type,
    onClear = () => {};
  let className;

  function clearMessage() {
    onClear();
  }

  $: switch (type) {
    case ERROR_CRITICAL:
      className = 'alert-danger';
      break;
    case ERROR_WARNING:
      className = 'alert-warning';
      break;
    default:
      className = 'alert-primary';
  }
</script>

<style>
  span {
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    margin-left: 0.5em;
    font-size: 0.7em;
    text-transform: uppercase;
  }
</style>

<div class="alert {className}">
  {error}
  <span on:click={clearMessage}>{CLEAR}</span>
</div>
